/* ============================================================
   product.js — PDP interactions
   Media gallery (thumbs, swipe strip, zoom), variant pills,
   size sheet, dialogs, review photo zoom, shipping calculator.
   Complements theme.js (AJAX add + select variant resolution).
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var money = function (cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };
  var fmtBRL = function (value) {
    return Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };
  var openDialog = function (dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  /* ---------- Section init ---------- */
  function init(root) {
    if (!root || root.dataset.productJsInit === 'true') return;
    root.dataset.productJsInit = 'true';

    var form = $('[data-product-form]', root);
    var jsonEl = $('#product-json', root);
    var variants = [];
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (e) { variants = []; }
    if (!form || !variants.length) return;

    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var urgency = $('[data-urgency-badge]', root);
    var urgencyText = $('[data-urgency-text]', root);
    var shipsBadge = $('[data-ships-badge]', root);
    var notifyBody = $('[data-notify-body]', root);
    var notifyVariantId = $('[data-notify-variant-id]', root);
    var notifySubmit = $('[data-notify-submit]', root);
    var notifySelection = $('[data-notify-selection]', root);
    /* Selects de opção podem estar FORA do form (multi-opção) — sempre buscar pelo root
       [data-product-section]; data-option-position define a ordem das opções. */
    var optionSelects = $$('[data-variant-select]', root);
    var current = null; /* variante resolvida; null = combinação inexistente */
    var hasAvailableVariant = variants.some(function (variant) { return variant.available; });

    function findById(id) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i];
      return null;
    }
    function sortedSelects() {
      return optionSelects.slice().sort(function (a, b) {
        return (parseInt(a.dataset.optionPosition, 10) || 99) - (parseInt(b.dataset.optionPosition, 10) || 99);
      });
    }
    function selectionFromSelects() {
      return sortedSelects().map(function (s) { return s.value; });
    }
    function findByOptions(selected) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.length !== selected.length) continue;
        if (variants[i].options.every(function (o, idx) { return o === selected[idx]; })) return variants[i];
      }
      return null;
    }

    /* ---------- Variants ---------- */
    function labelFor(btn, state) {
      if (state === 'available') return btn.dataset.addLabel || btn.dataset.label || btn.textContent;
      if (state === 'soldout') return btn.dataset.unavailableLabel || btn.textContent;
      return btn.dataset.invalidLabel || btn.dataset.unavailableLabel || btn.textContent;
    }
    function updateBuyButtons(state) {
      /* state: 'available' | 'soldout' | 'invalid' (combinação inexistente) */
      root.dataset.variantState = state;
      var variantStatus = $('[data-variant-status]', root);
      if (variantStatus) { variantStatus.hidden = state !== 'invalid'; variantStatus.textContent = state === 'invalid' ? variantStatus.dataset.invalidMessage : ''; }
      if (addBtn) {
        addBtn.disabled = state !== 'available' || form.dataset.cartSubmitting === 'true';
        addBtn.textContent = labelFor(addBtn, state);
      }
      $$('[data-sticky-add]', root).forEach(function (b) {
        b.disabled = state !== 'available' || form.dataset.cartSubmitting === 'true';
        b.textContent = labelFor(b, state);
      });
      $$('[data-size-open]', root).forEach(function (b) {
        b.disabled = form.dataset.cartSubmitting === 'true';
        b.textContent = !hasAvailableVariant
          ? (b.dataset.notifyLabel || b.dataset.unavailableLabel || b.textContent)
          : (state === 'available' ? b.dataset.addLabel || b.textContent : b.dataset.chooseLabel || b.dataset.unavailableLabel || b.textContent);
      });
      /* Preserva o span de preço; o aviso substitui a compra quando a seleção está esgotada. */
      $$('[data-sheet-add]', root).forEach(function (b) {
        b.disabled = state !== 'available' || form.dataset.cartSubmitting === 'true';
        b.hidden = state !== 'available';
      });
    }

    function syncNotifyVariant(v) {
      if (notifySelection) notifySelection.textContent = v ? v.options.join(' / ') : '';
      if (notifyBody) {
        notifyBody.value = v
          ? notifyBody.dataset.notifyPrefix + ' (' + v.options.join(' / ') + ') — ' + notifyBody.dataset.notifyUrl + '?variant=' + v.id
          : '';
        notifyBody.disabled = !v;
      }
      if (notifyVariantId) {
        notifyVariantId.value = v ? String(v.id) : '';
        notifyVariantId.disabled = !v;
      }
      if (notifySubmit) notifySubmit.disabled = !v;
      $$('[data-notify-open]', root).forEach(function (button) {
        button.disabled = !v;
        button.hidden = !v || v.available;
      });
    }

    function applyVariant(v, opts) {
      opts = opts || {};
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;
      syncNotifyVariant(v);

      /* Espelha TODOS os selects (multi-opção fora do form + espelho oculto dos pills) */
      optionSelects.forEach(function (s) {
        var pos = parseInt(s.dataset.optionPosition, 10);
        var val = pos ? v.options[pos - 1] : v.options[v.options.length - 1];
        if (val != null) s.value = val;
      });

      /* Pills (coluna info + size sheet) */
      var title = v.options.join(' / ');
      $$('[data-option-pill]', root).forEach(function (pill) {
        var isSel = pill.dataset.variantTitle === title;
        pill.classList.toggle('is-selected', isSel);
        pill.setAttribute('aria-pressed', isSel ? 'true' : 'false');
      });

      var sizeValue = $('[data-size-value]', root);
      if (sizeValue) sizeValue.textContent = title;

      var priceEl = $('[data-price]', root);
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;

      var stickyPrice = $('[data-sticky-price]', root);
      if (stickyPrice) stickyPrice.textContent = money(v.price_cents);
      var sheetPrice = $('[data-sheet-price]', root);
      if (sheetPrice) sheetPrice.textContent = money(v.price_cents);

      updateBuyButtons(v.available ? 'available' : 'soldout');
      if (v.featured_media_id != null) {
        setActiveMedia(ids.indexOf(String(v.featured_media_id)), opts.updateUrl ? 'variant' : 'init');
      }

      if (urgency) {
        var show = v.available && v.inventory_tracked && v.inventory_policy !== 'continue' && v.inventory > 0 && v.inventory <= 5;
        if (show && urgencyText && v.urgency_html) urgencyText.innerHTML = v.urgency_html;
        urgency.classList.toggle('is-hidden', !show);
      }
      if (shipsBadge) shipsBadge.hidden = !v.available;

      if (opts.updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    }

    /* Combinação inexistente: limpa o id e bloqueia a compra (nunca reaproveita variante anterior) */
    function applyNoMatch(opts) {
      opts = opts || {};
      current = null;
      if (idInput) idInput.value = '';
      syncNotifyVariant(null);
      updateBuyButtons('invalid');
      var unavailableLabel = addBtn ? labelFor(addBtn, 'invalid') : '';
      ['[data-price]', '[data-sticky-price]', '[data-sheet-price]', '[data-size-value]'].forEach(function (selector) {
        var element = $(selector, root);
        if (element) element.textContent = unavailableLabel;
      });
      if (urgency) urgency.classList.add('is-hidden');
      if (shipsBadge) shipsBadge.hidden = true;
      if (opts.updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }
    }

    /* Re-resolve a seleção atual e sincroniza botões/idden — usado por theme.js ao
       restaurar o botão após o envio (respeita troca de variante durante o request
       e não reabilita variante esgotada). */
    function syncButtons() {
      /* Sem selects (produto de variante única): resolve pelo hidden id atual */
      var match = optionSelects.length
        ? findByOptions(selectionFromSelects())
        : (idInput && idInput.value ? findById(idInput.value) : null);
      if (match) {
        current = match;
        if (idInput) idInput.value = match.id;
        updateBuyButtons(match.available ? 'available' : 'soldout');
      } else {
        current = null;
        if (idInput) idInput.value = '';
        updateBuyButtons('invalid');
      }
      syncNotifyVariant(match);
    }
    if (rootSync) rootSync.set(root, syncButtons);

    /* Pills (coluna info + sheet) */
    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-option-pill]');
      if (!pill || pill.disabled) return;
      e.preventDefault();
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.join(' / ') === pill.dataset.variantTitle) { v = variants[i]; break; }
      }
      if (!v) return;
      applyVariant(v, { updateUrl: true }); /* espelha os selects internamente */
    });

    /* Selects de opção (multi-opção fora do form e espelho oculto) — product.js é o
       único dono da resolução na PDP; theme.js não escuta mais data-variant-select. */
    root.addEventListener('change', function (e) {
      var select = e.target.closest('[data-variant-select]');
      if (!select) return;
      var match = findByOptions(selectionFromSelects());
      if (match) applyVariant(match, { updateUrl: true });
      else applyNoMatch({ updateUrl: true });
    });

    /* ---------- Mídia ---------- */
    var stage = $('.product__stage', root);
    var strip = $('[data-media-strip]', root);
    var thumbs = $$('[data-thumb]', root);
    var dotsWrap = $('[data-media-dots]', root);
    var slides = strip ? $$('[data-media-item]', strip) : [];
    var frames = stage ? $$('[data-media-item]', stage) : [];
    var ids = (slides.length ? slides : frames).map(function (el) { return el.dataset.mediaId; });

    function setActiveMedia(index, source) {
      if (index < 0 || index >= ids.length) return;
      var id = ids[index];
      slides.forEach(function (slide) { slide.classList.toggle('is-active', slide.dataset.mediaId === id); });
      frames.forEach(function (f) { f.classList.toggle('is-active', f.dataset.mediaId === id); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === id); });
      if (dotsWrap) {
        $$(':scope > *', dotsWrap).forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      }
      if (source !== 'strip' && strip && strip.clientWidth > 0 && slides[index]) {
        var target = slides[index].offsetLeft - (strip.clientWidth - slides[index].offsetWidth) / 2;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        strip.scrollTo({ left: Math.max(0, target), behavior: source === 'init' || reduceMotion ? 'instant' : 'smooth' });
      }
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setActiveMedia(i, 'thumb'); });
    });

    if (strip && slides.length) {
      var ticking = false;
      strip.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var idx = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
          setActiveMedia(Math.max(0, Math.min(idx, slides.length - 1)), 'strip');
        });
      }, { passive: true });
    }

    /* Zoom desktop (transform-origin segue o mouse) */
    $$('[data-zoom-frame]', root).forEach(function (frame) {
      frame.addEventListener('mousemove', function (e) {
        var r = frame.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        frame.style.setProperty('--zx', x.toFixed(1) + '%');
        frame.style.setProperty('--zy', y.toFixed(1) + '%');
      });
      frame.addEventListener('mouseleave', function () {
        frame.style.removeProperty('--zx');
        frame.style.removeProperty('--zy');
      });
    });

    /* ---------- Dialogs ---------- */
    var notifyReturnFocus = null;
    var notifyDialog = $('[data-notify-dialog]', root);
    if (notifyDialog && $('[data-notify-feedback]', notifyDialog)) openDialog(notifyDialog);
    if (notifyDialog) notifyDialog.addEventListener('close', function () {
      if (notifyReturnFocus && notifyReturnFocus.isConnected) notifyReturnFocus.focus({ preventScroll: true });
      notifyReturnFocus = null;
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-open]')) {
        openDialog($('[data-size-guide-dialog]', root));
        return;
      }
      if (e.target.closest('[data-notify-open]')) {
        var notifySheet = $('[data-size-sheet]', root);
        if (notifySheet && notifySheet.open) {
          notifyReturnFocus = $('[data-size-open]', root);
          notifySheet.close();
        }
        openDialog($('[data-notify-dialog]', root));
        return;
      }
      if (e.target.closest('[data-size-open]')) {
        openDialog($('[data-size-sheet]', root));
        return;
      }
      var closer = e.target.closest('[data-dialog-close]');
      if (closer) {
        var dialog = closer.closest('dialog');
        if (dialog) dialog.close();
        return;
      }
      if (e.target.closest('[data-sheet-guide]')) {
        var sheet = $('[data-size-sheet]', root);
        if (sheet) sheet.close();
        return;
      }
      var photo = e.target.closest('[data-photo-zoom]');
      if (photo) {
        var zoomDialog = $('[data-review-zoom]', root);
        var zoomImg = $('[data-review-zoom-img]', root);
        if (zoomDialog && zoomImg) {
          zoomImg.src = photo.dataset.photoZoom;
          openDialog(zoomDialog);
        }
      }
    });

    /* Sheet: adicionar dispara o submit do form (theme.js faz o AJAX) */
    root.addEventListener('click', function (e) {
      var sheetAdd = e.target.closest('[data-sheet-add]');
      if (!sheetAdd || sheetAdd.disabled) return;
      var sheet = $('[data-size-sheet]', root);
      if (sheet) sheet.close();
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });

    /* ---------- Calculadora de frete ---------- */
    initShipping(root);

    /* Estado inicial: prioriza ?variant= da URL; senão o hidden id renderizado
       (current_variant); selects só decidem quando existem (multi-opção/pills). */
    var urlVariant = new URLSearchParams(window.location.search).get('variant');
    var initial = urlVariant ? findById(urlVariant) : null;
    if (!initial && idInput && idInput.value) initial = findById(idInput.value);
    if (initial) applyVariant(initial, { updateUrl: false });
    else if (optionSelects.length) {
      var selMatch = findByOptions(selectionFromSelects());
      if (selMatch) applyVariant(selMatch, { updateUrl: false });
      else applyNoMatch({ updateUrl: false });
    }
  }

  /* ---------- Ponte com theme.js (restaurar botão após add-to-cart) ---------- */
  var rootSync = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  function syncForm(form) {
    var root = form && form.closest ? form.closest('[data-product-section]') : null;
    if (!root || !rootSync) return false;
    var fn = rootSync.get(root);
    if (!fn) return false;
    fn();
    return true;
  }

  function initShipping(root) {
    var ship = $('[data-ship-root]', root);
    if (!ship) return;
    var form = $('[data-ship-form]', ship);
    var input = $('[data-ship-cep]', ship);
    var submitBtn = $('[data-ship-submit]', ship);
    var errorEl = $('[data-ship-error]', ship);
    var statusEl = $('[data-ship-status]', ship);
    var results = $('[data-ship-results]', ship);
    var cityEl = $('[data-ship-city]', ship);
    var listEl = $('[data-ship-list]', ship);

    var strings = {};
    try { strings = JSON.parse(ship.dataset.shipStrings || '{}'); } catch (e) { strings = {}; }
    var requestVersion = 0;
    var pending = false;
    /* Label inicial capturado uma vez: restore nunca reaplica "Calculando..." de request anterior. */
    var initialLabel = submitBtn ? submitBtn.textContent : '';
    var activeOperation = null;
    var REQUEST_TIMEOUT = 8000;
    var POLL_INTERVAL = 800;
    var MAX_POLLS = 40;
    var TOTAL_TIMEOUT = 40000;

    function isCurrent(operation) {
      return activeOperation === operation && !operation.cancelled && operation.version === requestVersion;
    }

    function cancelledError() {
      var error = new Error('shipping_cancelled');
      error.name = 'AbortError';
      return error;
    }

    /* Cada espera pertence à operação. Sem work, espera o intervalo de polling; com work,
       o limite cobre fetch E leitura do JSON. Cancelamento também encerra promises sem AbortController. */
    function waitFor(operation, ms, work) {
      return new Promise(function (resolve, reject) {
        if (!isCurrent(operation)) { reject(cancelledError()); return; }
        var remaining = operation.deadline - Date.now();
        if (remaining <= 0) { reject(new Error('shipping_timeout')); return; }
        var settled = false;
        function finish(error, value) {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          var index = operation.cancelers.indexOf(cancel);
          if (index !== -1) operation.cancelers.splice(index, 1);
          if (error) reject(error);
          else if (!isCurrent(operation)) reject(cancelledError());
          else resolve(value);
        }
        var cancel = function () { finish(cancelledError()); };
        var timer = setTimeout(function () {
          finish(work || remaining <= ms ? new Error('shipping_timeout') : null);
        }, Math.min(ms, remaining));
        operation.cancelers.push(cancel);
        if (work) {
          Promise.resolve().then(function () {
            if (!isCurrent(operation)) throw cancelledError();
            return work();
          }).then(function (value) { finish(null, value); }, function (error) { finish(error); });
        }
      });
    }

    function request(operation, url, options, parseBody) {
      options = options || {};
      options.cache = 'no-store';
      if (operation.controller) options.signal = operation.controller.signal;
      return waitFor(operation, REQUEST_TIMEOUT, function () {
        return fetch(url, options).then(function (response) {
          if (!isCurrent(operation)) throw cancelledError();
          if (!response.ok) throw new Error('shipping_http_' + response.status);
          return parseBody === false ? null : response.json();
        });
      });
    }

    function restoreButton() {
      pending = false;
      if (form) form.setAttribute('aria-busy', 'false');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = initialLabel || t('submit'); }
    }

    function stopOperation(operation) {
      operation.cancelled = true;
      operation.cancelers.slice().forEach(function (cancel) { cancel(); });
      if (operation.controller) operation.controller.abort();
    }

    function cancelActive() {
      if (!activeOperation) return;
      stopOperation(activeOperation);
      activeOperation = null;
      restoreButton();
    }

    function invalidateRates(reason) {
      var hadRates = results && !results.hidden;
      requestVersion++;
      cancelActive();
      if (results) results.hidden = true;
      showError('');
      if (hadRates && reason) showError(t(reason));
    }
    document.addEventListener('cart:rendered', function () { invalidateRates('cart_changed'); });

    function t(key, tokens) {
      var s = strings[key] || '';
      if (tokens) Object.keys(tokens).forEach(function (k) { s = s.replace('__' + k + '__', tokens[k]); });
      return s;
    }

    function showError(msg, invalidCep) {
      if (errorEl) { errorEl.textContent = msg || ''; errorEl.hidden = !msg; }
      if (statusEl) statusEl.textContent = msg || '';
      if (input) {
        if (invalidCep) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      }
      if (msg && results) results.hidden = true;
    }

    if (input) {
      input.addEventListener('input', function () {
        var d = input.value.replace(/\D/g, '').slice(0, 8);
        input.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
        invalidateRates('cep_changed');
      });
    }

    if (!form || !input) return;

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* Fluxo oficial assíncrono do Shopify: POST prepare_shipping_rates.json seguido de
       polling em async_shipping_rates.json, ambos com a MESMA query shipping_address.
       null = ainda pendente; {shipping_rates:[]} = concluído sem opções; 404/HTTP/malformado = erro. */
    function prepareAndPoll(operation, base, qs) {
      var attempts = 0;
      function poll() {
        if (!isCurrent(operation)) return Promise.reject(cancelledError());
        attempts++;
        return request(operation, base + '/async_shipping_rates.json' + qs, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (data) {
          if (!isCurrent(operation)) throw cancelledError();
          if (data === null) {
            if (attempts >= MAX_POLLS) throw new Error('rates_polls_exhausted');
            return waitFor(operation, POLL_INTERVAL).then(poll);
          }
          if (!data || !Array.isArray(data.shipping_rates)) throw new Error('rates_malformed');
          return data.shipping_rates;
        });
      }
      /* POST prepare: 2xx com corpo vazio conta como sucesso — não fazemos parse do corpo. */
      return request(operation, base + '/prepare_shipping_rates.json' + qs, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }, false).then(poll);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (pending) return; /* bloqueia duplo submit enquanto o cálculo atual está pendente */
      var digits = input.value.replace(/\D/g, '');
      if (digits.length !== 8) { showError(t('invalid'), true); return; }
      cancelActive(); /* garante abort/timers limpos (sem operação ativa é no-op) */
      var operation = {
        version: ++requestVersion,
        controller: typeof AbortController !== 'undefined' ? new AbortController() : null,
        cancelers: [],
        cancelled: false,
        deadline: Date.now() + TOTAL_TIMEOUT
      };
      activeOperation = operation;
      pending = true;
      showError('');
      form.setAttribute('aria-busy', 'true');
      if (statusEl) statusEl.textContent = t('loading');
      if (results) results.hidden = true;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = t('loading'); }

      var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      /* Endpoint relativo same-origin — preserva o prefixo de idioma de routes.cart_url. */
      var zip = digits.slice(0, 5) + '-' + digits.slice(5);
      /* ViaCEP fornece cidade/UF; a Shopify retorna as tarifas disponíveis para a sacola atual. */
      Promise.all([
        request(operation, 'https://viacep.com.br/ws/' + digits + '/json/')
          .catch(function (error) { return { lookup_failed: true, reason: error.message }; }),
        request(operation, cartUrl + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      ])
        .then(function (step1) {
          if (!isCurrent(operation)) return;
          var via = step1[0];
          var cart = step1[1];
          if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('rates_malformed');
          if (cart.item_count === 0) { showError(t('cart_empty')); return; }
          /* BR exige province no endpoint (422 sem ela) — a UF vem do ViaCEP. */
          if (!via || via.lookup_failed) {
            var reason = via && via.reason || '';
            showError(t(reason === 'shipping_timeout' ? 'timeout' : reason === 'shipping_http_429' ? 'rate_limited' : 'lookup_error')); return;
          }
          if (via.erro) { showError(t('cep_not_found'), true); return; }
          if (!/^[A-Z]{2}$/.test(via.uf || '')) { showError(t('lookup_error')); return; }
          var qs = '?shipping_address%5Bzip%5D=' + encodeURIComponent(zip) +
            '&shipping_address%5Bcountry%5D=BR&shipping_address%5Bprovince%5D=' + encodeURIComponent(via.uf);
          return prepareAndPoll(operation, cartUrl, qs)
            .then(function (rates) {
              if (!isCurrent(operation)) return;
              if (!rates.length) { showError(t('not_found')); return; }
              if (rates.some(function (rate) { return !rate || (typeof rate.price !== 'string' && typeof rate.price !== 'number') || String(rate.price).trim() === '' || !Number.isFinite(Number(rate.price)) || Number(rate.price) < 0 || typeof (rate.presentment_name || rate.name || rate.title) !== 'string' || !(rate.presentment_name || rate.name || rate.title).trim(); })) throw new Error('rates_malformed');
              if (cityEl) {
                var place = via && !via.erro ? via.localidade + ' - ' + via.uf : '';
                cityEl.textContent = place ? t('city', { city: place }) : '';
              }
              if (listEl) {
                listEl.innerHTML = rates.map(function (q) {
                  var isFree = Number(q.price) === 0;
                  var label = q.presentment_name || q.name || q.title || '';
                  var eta = q.description || '';
                  var days = Array.isArray(q.delivery_days) ? q.delivery_days.filter(function (day) { return (typeof day === 'number' || typeof day === 'string') && String(day).trim() !== ''; }).map(Number).filter(function (day) { return Number.isInteger(day) && day >= 0; }).sort(function (a, b) { return a - b; }) : [];
                  if (!eta && days.length) {
                    var dmin = days[0], dmax = days[days.length - 1];
                    eta = dmin === dmax ? t('days_one', { count: dmin }) : t('days_range', { min: dmin, max: dmax });
                  }
                  var extra = eta ? ' <em class="ship-calc__eta">' + escapeHtml(eta) + '</em>' : '';
                  return '<li><span>' + escapeHtml(label) + extra + '</span>' +
                    '<strong' + (isFree ? ' class="ship-free"' : '') + '>' + (isFree ? t('free') : fmtBRL(q.price)) + '</strong></li>';
                }).join('');
              }
              if (results) results.hidden = false;
              var intro = $('[data-ship-intro]', ship);
              if (intro) intro.hidden = true;
              if (statusEl) statusEl.textContent = t('rates_ready');
            });
        })
        .catch(function (error) {
          if (!isCurrent(operation)) return;
          var key = error.message === 'shipping_timeout' || error.message === 'rates_polls_exhausted' ? 'timeout' : error.message === 'shipping_http_429' ? 'rate_limited' : error.message === 'rates_malformed' ? 'malformed' : 'error';
          showError(t(key));
        })
        .finally(function () {
          if (!isCurrent(operation)) return; /* operação antiga não reseta pending/botão da nova */
          stopOperation(operation);
          activeOperation = null;
          restoreButton();
        });
    });
  }

  /* ---------- Boot ---------- */
  function boot(ctx) {
    $$('[data-product-section]', ctx || document).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

  window.JoaninhaProduct = { init: init, syncForm: syncForm };
})();
